import * as Html from "../../util/Html.ts";
function toggle(){
    let node = $(this)
    node.toggleClass('fw-background-branded');
    node.find('input').prop('disabled',!node.hasClass('fw-background-branded'))
}

function init(node){
    node.css('cursor','pointer')
    node.find('input').prop('disabled',!node.hasClass('fw-background-branded'))
    node.on('click',toggle);
}
function destroy(node){
    node.off('click',toggle);
}
export{init,destroy}
Html.registerWidget('widget/specific/mprecipecat',{init:init,destroy:destroy})
